import * as React from 'react';
import './profiletune-style.css';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
// import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ImageLoaderComponent } from '../../../../toolkit/imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from '../../../../toolkit/imageloader/imageloadercss';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { ToneCardCSSStyle } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ToneCardImageLoaderCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardimageloadercss';
import { ToneEvenCardImageLoaderCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/toneevencardimageloader';
import { ToneMobileCardImageLoaderCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonemobilecardimageloadercss';
import { ToneMobileEvenCardImageLoaderCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonemobileevencardimageloader';
import { ProfileTuneCardComponentProps, ProfileTuneCardComponentState} from './profiletunecardcomponent';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { ProfileToneComponent } from '../../../popup/profiletone/profiletonecomponent';
import { ToneOptionsType } from '../../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { SubscriptionPlanComponent } from '../../../popup/subscription_plan/subscriptionplancomponent';
import { ToneCardComponentProps } from '../../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { PlayerWithProgressComponent } from '../../../../toolkit/player/playerwithprogress/playerwithprogress';
import { PlayerHandler } from 'src/com/sixdee/crbtportal/utils/player/playmanager';
import {  AudioPlayerWithProgress, AudioPlayerWithProgressHandler } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
// import { RoutingFeatures } from '../../../../navigation/routingfeature';

export class ProfileTuneCardViewImpl extends UIComponentViewImpl<UIDataModel> implements PlayerHandler, AudioPlayerWithProgressHandler
{
    private playerComponent: PlayerWithProgressComponent | null;
    private playerComponentMob: PlayerWithProgressComponent | null;
    private initialStateOfTonePlaying: boolean;
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private mobileImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private mobileEvenImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private popUpComponent: PopUpWrapperComponent;
    private audioPlayerWithProgress: AudioPlayerWithProgress;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
      
        this.imageLoaderCSSStyle = new ToneCardImageLoaderCSSStyleImpl(context);
        this.mobileImageLoaderCSSStyle = new ToneMobileCardImageLoaderCSSStyleImpl(context);
        this.evenImageLoaderCSSStyle = new ToneEvenCardImageLoaderCSSStyleImpl(context);
        this.mobileEvenImageLoaderCSSStyle = new ToneMobileEvenCardImageLoaderCSSStyleImpl(context);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);

        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
    }
     

    draw(props: ProfileTuneCardComponentProps, state: ProfileTuneCardComponentState, cssStyle: ToneCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
                <div id="profiletune-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
        
                 <div id="profiletune-col2-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                <div id="profiletune-col-wrapper">
                    {
                        this.getMobileView(props, state, cssStyle)
                    }
                </div>
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: ProfileTuneCardComponentProps, state: ProfileTuneCardComponentState, cssStyle: ToneCardCSSStyle):JSX.Element
    {
        return(
            <>
                 <div  id="profiletune-main-wrapper" onClick={this.onSelected} key={props.position} style={props.cardStyle.getToneWrapperCSSStyle(props.marginTop)}>
                    {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenImageLoaderCSSStyle} context={props.context}/>}
                    {<PlayerWithProgressComponent isAutoPlayRequired={false} position={props.position}  id={props.toneDto.getId()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={props.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>}
                <div style={props.cardStyle.getDetailsDivCssStyle()}>
                   
                   <div style={props.cardStyle.getTitleDivCSSStle()}>
                     <div style={{height: "30px",textAlign:"left", overflow: "hidden",marginTop:'20px',marginBottom:'3px'}}>
                        <label title={props.toneDto.getArtistName()} style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                  <div id="featured-tone-card-button" style={cssStyle.getButtonCSSStyle()} onClick={this.onSelected}>
                        {
                            <>
                            <div id="button-div">
                              
                                  {<>
                                      {<div id="featured-buy-tone-card-option-div" style={{width:"200px"}}>
                                       <img   src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='24px' height='24px'/>                                   
                                              <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"featured-buy-tone-card-option-label":"featured-buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.set)}</label>
                                      </div>}  
                                     
                                 </> }
                                
                             </div>
                             <div id="button-col-div">
                                  {<>
                                      {<div id="featured-buy-tone-card-option-div" style={{width:"200px"}}>
                                       <img  src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='12px' height='12px'/>                                   
                                              <label id={this.getUIProps().context.getUserContext().getLanguage() === LanguageConst.ENGLISH ?"featured-buy-tone-card-option-label":"featured-buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.set)}</label>
                                      </div>}  
                                     
                                 </> }
                              </div> 
                             
                          </>  
                                 
                        }
                       
                    </div>
                 </div>
                
            </div>
            </>
        );
    }

    updateProgress(percentage: number): void 
    {
        this.playerComponent !== null && this.playerComponent.updateProgress(percentage);
        this.playerComponentMob !== null && this.playerComponentMob.updateProgress(percentage);
    }

    onPlayClicked(): void
    {

        this.initialStateOfTonePlaying = true;

        this.getContext().getPlayerManager()
                    .startPlay((this.getUIProps() as ToneCardComponentProps).toneDto.getToneUrl(), this);
        this.audioPlayerWithProgress.startProgress(this);
    }

    setPlayerWithProgress(audioPlayerWithProgress: AudioPlayerWithProgress)
    {
        this.audioPlayerWithProgress = audioPlayerWithProgress;
        if(this.playerComponent !== null && this.playerComponent !== undefined)
        {
            this.playerComponent.updateProgress(0);
            this.playerComponent.onStopClicked();
            this.getContext().getPlayerManager().release();
            this.audioPlayerWithProgress.startProgress(undefined);
        }
        // this.playerComponent !== null && this.playerComponent.setPlayerWithProgress(this);
    }
  
    onPlayStart()
    {

        if(this.playerComponent !== null)
        {
    //         this.audioPlayerWithProgress.startProgress(this);
            this.playerComponent.playStart();
            // this.onPlayClicked();
        }
    }

    protected onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
    }

    onPlayComplete(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
        this.playerComponentMob !== null && this.playerComponentMob.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
        this.playerComponentMob !== null && this.playerComponentMob.onPlayStop();
    }
    
    getToneOptionsPart(cssStyle: ToneCardCSSStyle)
    {
        return (
            <div style={cssStyle.getOnHoverCSSStyle()}/>);
    }

    showPopup(msg: any,title:string,type: AlertType)
    {

        // this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
        
        if(title === Strings.subscription_plan)
        {
            if(type === AlertType.SUCCESS){
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

            }
            else if(type === AlertType.ERROR){
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

            }
            else if(type === AlertType.AUTHENTICATE){

                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                    <SubscriptionPlanComponent data={msg} id={this.getUIProps().context.getResources().getString(Strings.profile_tunes)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={(id: string, respMsg: string, alertType: AlertType)=>{this.closePopup();this.showPopup(id, respMsg,alertType);}} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
            }
    
        }
        else if(title === Strings.profile_tunes)
        {
            if(type === AlertType.SUCCESS){
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

            }
            else if(type === AlertType.ERROR){
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

            }
    
        }
    }

    protected getPopupResult():void{
        
    }

   
    protected getPopUpWrapper():PopUpWrapperComponent
    {
        return this.popUpComponent;
    }
    protected onSelected()
    {

        this.playerComponent !== null && this.playerComponent.onPlayComplete();
        this.playerComponentMob !== null && this.playerComponentMob.onPlayComplete();

        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
               <ProfileToneComponent   getPopupWrapper={this.getPopUpWrapper} showPopup={this.showPopup}   toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ProfileTuneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
    }
    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    getMobileView(props: ProfileTuneCardComponentProps, state: ProfileTuneCardComponentState, cssStyle: ToneCardCSSStyle):JSX.Element
    {
        return(
            <>
                 <div id="profiletune-main-wrapper" onClick={this.onSelected} key={props.position} style={props.cardStyle.getMobileToneWrapperCSSStyle(props.marginTop)}>
                    {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.mobileImageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.mobileEvenImageLoaderCSSStyle} context={props.context}/>}
                        {<PlayerWithProgressComponent isAutoPlayRequired={false} position={props.position}  id={props.toneDto.getId()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={props.mobilePlayerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponentMob=item} context={this.getUIProps().context}/>}
                <div style={{objectFit: 'cover', height: '22px',display: "flex", position: "relative", flexDirection: "row",flexFlow: "row wrap", backgroundColor: this.getUIProps().context.getResources().getColor(Colors.color_5)}}>
                   
                   <div style={{height: '22px', flex: 1}}>
                     <div style={{height: "30px",textAlign:"left", overflow: "hidden",marginTop:'10px',marginBottom:'3px'}}>
                        <label title={props.toneDto.getArtistName()} style={props.cardStyle.getMobileToneNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                  <div id="featured-tone-card-button" style={cssStyle.getButtonCSSStyle()} onClick={this.onSelected}>
                        {
                            <>
                            <div id="button-div">
                              
                                  {<>
                                      {<div id="featured-buy-tone-card-option-div" style={{width:"200px"}}>
                                       <img   src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='24px' height='24px'/>                                   
                                              <label id={this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"featured-buy-tone-card-option-label":"featured-buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.set)}</label>
                                      </div>}  
                                     
                                 </> }
                                
                             </div>
                             <div id="button-col-div">
                                  {<>
                                      {<div id="featured-buy-tone-card-option-div" style={{width:"200px"}}>
                                       <img  src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='12px' height='12px'/>                                   
                                              <label id={this.getUIProps().context.getUserContext().getLanguage() === LanguageConst.ENGLISH ?"featured-buy-tone-card-option-label":"featured-buy-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.set)}</label>
                                      </div>}  
                                     
                                 </> }
                              </div> 
                             
                          </>  
                                 
                        }
                       
                    </div>
                 </div>
                 {/* <div style={cssStyle.getMobileButtonCSSStyle()}  onClick={this.onSelected}>
                        <img  src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='20px' height='20px'/>
                    <label id={this.getUIProps().context.getUserContext().getLanguage() === LanguageConst.ENGLISH ? "profiletune-tone-card-option-label" : "profiletune-tone-card-option-label-burmese"}>{this.getContext().getResources().getString(Strings.settings)}</label>
                    </div> */}
            </div>
            </>
        );
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunecard/profiletunecardview.tsx